import nheBaseline from './nhe_baseline.json' with { type: "json" };
import householdBurden from './household_burden.json' with { type: "json" };
import medicalDebt from './medical_debt.json' with { type: "json" };
import medSchoolDebt from './med_school_debt.json' with { type: "json" };
import federalDebtBaseline from './federal_debt_baseline.json' with { type: "json" };
import incomeBase from './income_base.json' with { type: "json" };
import workforceBaseline from './workforce_baseline.json' with { type: "json" };

export const BaselineData = {
    nheBaseline,
    householdBurden,
    medicalDebt,
    medSchoolDebt,
    federalDebtBaseline,
    incomeBase,
    workforceBaseline
};
